import { render } from "./email.vue?vue&type=template&id=37815577"
import script from "./email.vue?vue&type=script&lang=js"
export * from "./email.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/components/form/input-only/email.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37815577"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37815577', __exports__)) {
    console.log('reload')
    api.reload('37815577', __exports__)
  }
  
  module.hot.accept("./email.vue?vue&type=template&id=37815577", () => {
    console.log('re-render')
    api.rerender('37815577', render)
  })

}


export default __exports__